import React, { memo, useCallback, useState } from 'react';
import { EditIcon } from '@ui/components';
import {
  IFactory,
  deleteFactory as deleteFactoryById,
} from '@ui/api/v2/store.api';
import { Modal } from 'antd';
import { replaceSpaceByDash } from '../../utils/helpers';

interface IProps {
  factory: IFactory;
  setEditFactory: (factory: IFactory) => void;
  onDelete: (id: number) => void;
}

function FactoryCard({ factory, setEditFactory, onDelete }: IProps) {
  const [showModal, setShowModal] = useState(false);

  const onEditClick = useCallback(() => {
    setEditFactory(factory);
  }, [factory, setEditFactory]);

  const deleteFactory = useCallback(() => {
    setShowModal(false);
    void deleteFactoryById(factory.id);
    onDelete(factory.id);
  }, [factory, onDelete, setShowModal]);

  return (
    <div className="markets__item">
      <span>{replaceSpaceByDash(factory.name)}</span>
      <span>{factory.country.name}</span>
      <span />
      <div className="markets__controls">
        <EditIcon onClick={onEditClick} type="edit" />
        <EditIcon onClick={() => setShowModal(true)} type="remove" />
      </div>
      <Modal
        okButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'danger',
        }}
        cancelButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'primary',
        }}
        okText="Да"
        cancelText="Нет"
        title="Удаление фабрики"
        visible={showModal}
        onOk={deleteFactory}
        onCancel={() => setShowModal(false)}
      >
        <p>Вы уверены, что ходите удалить фабрику {factory.name}</p>
      </Modal>
    </div>
  );
}

export default memo(FactoryCard);



// WEBPACK FOOTER //
// ./src/components/Factories/FactoryCard.tsx